"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import _ from "underscore";
import Api from "../api/api";
import DisablingButton from "../components/disabling_button";
export default class extends React.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "state", {
      selectedOption: this.props.documentBatch.duplicateInvoice ? "duplicate-invoice" : "ignore"
    });
    __publicField(this, "handleOptionChange", (changeEvent) => {
      this.setState({
        selectedOption: changeEvent.target.value
      });
    });
    __publicField(this, "ignoreEntry", () => {
      this.setState({ completing: true });
      if (this.state.selectedOption == "ignore") {
        Api.DocumentBatches.ignore(
          this.props.documentBatch.id,
          this.state.reason
        ).then(() => {
          this.setState({ completing: false });
          this.props.ignoreEntryComplete();
        }, _.identity);
      } else {
        Api.DocumentBatches.ignoreAsDuplicate(
          this.props.documentBatch.id,
          // The duplicate option is only selectable when duplicateInvoice is set
          this.props.documentBatch.duplicateInvoice.id
        ).then(() => {
          this.setState({ completing: false });
          this.props.ignoreEntryComplete();
        }, _.identity);
      }
    });
  }
  render() {
    const duplicateInvoice = this.props.documentBatch.duplicateInvoice;
    const duplicateInvoiceText = duplicateInvoice ? `Duplicate of Invoice ${duplicateInvoice.number} for $${parseFloat(duplicateInvoice.source_invoice_amount).toFixed(2)} from ${duplicateInvoice.carrier_name}` : "";
    const draftCarrierInvoices = (this.props.documentBatch.carrier_invoices || []).filter((carrierInvoice) => carrierInvoice.state === "draft");
    return /* @__PURE__ */ jsx("div", { className: "modal__medium-container reply__mark-complete", children: /* @__PURE__ */ jsxs("div", { className: "row", children: [
      /* @__PURE__ */ jsx("div", { className: "small-10 column", children: /* @__PURE__ */ jsx("h3", { children: "Ignore All Groups" }) }),
      /* @__PURE__ */ jsxs("div", { className: "small-10 column", children: [
        /* @__PURE__ */ jsx("p", { children: "This step will remove the email from the New or Replies queue. Exceptions, however, will remain in the Exceptions or Waiting queue." }),
        draftCarrierInvoices.length > 0 && /* @__PURE__ */ jsx("div", { className: "alert-box alert-box--danger-light", children: /* @__PURE__ */ jsxs("span", { children: [
          /* @__PURE__ */ jsx("strong", { children: "Warning:" }),
          " You are about to delete a carrier invoice linked to the documents in this batch."
        ] }) })
      ] }),
      /* @__PURE__ */ jsxs("div", { className: "small-10 column", children: [
        /* @__PURE__ */ jsx("h6", { children: "Reason" }),
        duplicateInvoice && /* @__PURE__ */ jsxs("div", { className: "row ignore-entry-view__radio-option", children: [
          /* @__PURE__ */ jsx(
            "input",
            {
              type: "radio",
              checked: this.state.selectedOption == "duplicate-invoice",
              onChange: this.handleOptionChange,
              id: "duplicate-invoice",
              value: "duplicate-invoice"
            }
          ),
          /* @__PURE__ */ jsx("label", { htmlFor: "duplicate-invoice", children: duplicateInvoiceText })
        ] }),
        /* @__PURE__ */ jsxs("div", { className: "row ignore-entry-view__radio-option", children: [
          /* @__PURE__ */ jsx(
            "input",
            {
              type: "radio",
              checked: this.state.selectedOption == "ignore",
              onChange: this.handleOptionChange,
              id: "ignore",
              value: "ignore"
            }
          ),
          /* @__PURE__ */ jsx("label", { htmlFor: "ignore", children: "Other" })
        ] })
      ] }),
      this.state.selectedOption == "ignore" && /* @__PURE__ */ jsx("div", { className: "small-10 column", children: /* @__PURE__ */ jsx(
        "textarea",
        {
          value: this.state.reason || "",
          onChange: (e) => this.setState({
            reason: e.target.value
          })
        }
      ) }),
      /* @__PURE__ */ jsxs("div", { className: "small-10 column", children: [
        /* @__PURE__ */ jsx(
          DisablingButton,
          {
            disabled: this.state.completing,
            disabledText: "Ignoring...",
            onClick: this.ignoreEntry,
            className: "button--confirmation",
            children: "Ignore All Groups"
          }
        ),
        " ",
        "\xA0",
        /* @__PURE__ */ jsxs("span", { className: "button--cancel-wrapper", children: [
          /* @__PURE__ */ jsx("span", { children: "or" }),
          /* @__PURE__ */ jsx("button", { className: "button--cancel", onClick: this.props.onCancel, children: "cancel" })
        ] })
      ] })
    ] }) });
  }
}
